import React from 'react';
import { LevelType } from 'types/data/level';
import PropTypes from 'prop-types';

import { Container } from './styles';
import InfoLogLevel from 'components/molecules/containers/InfoLogLevel';

const Level5LevelModal = ({ level, levelConquered }) => {
    const data = [
        {
            active: levelConquered,
            title: 'Avaliação da Mentoria',
            url: 'https://forms.gle/8Rf5xb6dibBrHsPD7',
            target: '_blank'
        }
    ];
    return (
        <Container>
            <p>Desafio: </p>

            <h2>Conclua a avaliação de sua Mentoria</h2>

            <span>Faça os testes</span>

            <InfoLogLevel data={data} />
        </Container>
    );
};

Level5LevelModal.propTypes = {
    level: PropTypes.shape(LevelType),
    levelConquered: PropTypes.bool
};

export default Level5LevelModal;
